import { Card, CardContent } from "@/components/ui/card";
import React from "react";
import { NavLink } from "react-router-dom";

export interface QuickAccessCardProps {
  title: string;
  icon: React.ReactNode;
  to: string;
}

export const QuickAccessCard = ({ title, icon, to }: QuickAccessCardProps) => (
  <NavLink to={to} className="block">
    <Card className="hover:bg-accent cursor-pointer transition-colors">
      <CardContent className="flex items-center gap-3 p-4">
        <div className="flex items-center justify-center">{icon}</div>
        <div className="font-medium">{title}</div>
      </CardContent>
    </Card>
  </NavLink>
);
